var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex items-center justify-center h-8 w-8 bg-grey-100 rounded-full cursor-pointer",attrs:{"tabindex":"-1"},on:{"click":_vm.handleClick}},[_c('SvgLocationPin',{staticClass:"text-grey-400 h-4 w-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }